import { render } from "./AcExpansionPanel.vue?vue&type=template&id=27899bf6&scoped=true&ts=true"
import script from "./AcExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./AcExpansionPanel.vue?vue&type=script&lang=ts"

import "./AcExpansionPanel.vue?vue&type=style&index=0&id=27899bf6&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27899bf6"]])

export default __exports__